module.exports = __webpack_public_path__ + "img/cart-icon.c2e7a385c341dfceff935a8ba55999fe.svg";